// 部門v2 のフォーム: 既定の取引窓口で「新規登録」を選んだら取引窓口の入力欄を開く。
// 窓口は部門と同じ送信で一緒に保存される（取引窓口が 1 つも無い状態で部門だけ先に作るケース、支店統合 #3484）。
document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('select[data-trading-window-select]');
  const fields = document.getElementById('new-trading-window-fields');
  if (!select || !fields) return;

  const toggle = () => { fields.hidden = select.value !== 'new'; };
  select.addEventListener('change', toggle);
  toggle();
});
